var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullscreen = function SvgFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#445A64",
    d: "M18 0v6h-2V3.41l-3.29 3.3-1.42-1.42L14.59 2H12V0zM0 0v6h2V3.41l3.29 3.3 1.42-1.42L3.41 2H6V0zm18 18v-6h-2v2.59l-3.29-3.29-1.41 1.41L14.59 16H12v2zM6 18v-2H3.41l3.29-3.29-1.41-1.42L2 14.59V12H0v6z"
  })));
};
export default SvgFullscreen;